export default __webpack_public_path__ + "static/media/login-v2.b20c10ac.svg";